
<script>
    import { Line } from 'vue-chartjs'

    export default {
        extends: Line,
        props: ['chartdata', 'options'],
        mounted () {

            const ctx = document.createElement('canvas').getContext("2d");

            const gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
            gradientStroke.addColorStop(1, "#F8491B");
            gradientStroke.addColorStop(0.5, "#F12F3F");
            gradientStroke.addColorStop(0, "#DC1860");

            this.renderChart({
                responsive: true,
                maintainAspectRatio: false,
                height:300,
                labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                datasets: [
                    {
                        label: 'Data One',
                        // backgroundColor: '#f87979',
                        data: [40, 39, 10, 40, 39, 80, 40],
                        fill: false,
                        borderColor:               gradientStroke,
                        pointBorderColor:          gradientStroke,
                        pointBackgroundColor:      gradientStroke,
                        pointHoverBackgroundColor: gradientStroke,
                        pointHoverBorderColor:     gradientStroke
                    }
                ],


            }, {
                responsive: true, maintainAspectRatio: false,  borderWidth: 3,
                legend: {
                    display: false
                },
                scales : {
                    xAxes : [ {
                        gridLines : {
                            display : false
                        }
                    } ],
                    yAxes : [ {
                        gridLines : {
                            display : false
                        }
                    } ]
                }
            })
        }
    }
</script>

<style>
</style>